import { Component, OnInit, ElementRef, ViewChild, AfterViewInit, Input } from '@angular/core';

declare var $: any;
@Component({
    selector: 'wizard-tooltip',
    templateUrl: './tooltip.component.html',
    styleUrls: ['./tooltip.component.scss']
})
export class TooltipComponent implements OnInit, AfterViewInit {
    @Input() icon: string | null = 'circle blue info';
    @ViewChild('popup') popup: ElementRef;

    constructor() {}

    ngOnInit() {}

    ngAfterViewInit() {
        $(this.popup.nativeElement).popup({
            hoverable: true,
            inline: true
        });
    }
}
